<div class="modal-header">
  <h4 class="modal-title">
    {{ 'Doc::CustomerSalesPurchase:LocationChoice' | abpLocalization }}
  </h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
</div>

<div class="modal-body">
  @if (form) {
    <form [formGroup]="form" (ngSubmit)="save()">
      <div class="row row-cols-1 row-cols-md-4 my-2">
        <div class="col col-md-12">
          <label for="locationId" class="text-primary form-label" [dwInputRequired]="true">
            {{ 'Product::Stock:Location' | abpLocalization }}
          </label>
          <ng-select
            id="locationId"
            formControlName="locationId"
            bindLabel="name"
            bindValue="id"
            [dwApiSelect]="storageLocationSelect"
          >
            <ng-template ng-label-tmp let-item="item">
              <span [title]="item.name">{{ item.name }} - {{ item.code }}</span>
            </ng-template>
            <ng-template ng-option-tmp let-item="item">
              <span [title]="item.name">{{ item.name }} - {{ item.code }}</span>
            </ng-template>
          </ng-select>
        </div>
      </div>
    </form>
  }
</div>

<div class="modal-footer">
  <button class="btn btn-outline-primary ms-2" (click)="modal.dismiss()">
    {{ 'ERP::Cancel' | abpLocalization }}
  </button>
  <button class="btn btn-primary ms-2" (click)="save()">
    {{ 'ERP::Save' | abpLocalization }}
  </button>
</div>
